import axios from "axios";
import makeApiCall from "./axiosIndex";

const contractorsApis = {
  fetchContractor: (): Promise<any> =>
    makeApiCall<any>({ method: "get", url: "/seller/fetchContractor" }),
  deleteContractorById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "delete",
      url: `/seller/deleteContractorById?id=${id}`,
    }),
  createContractor: (data: any): Promise<any> =>
    makeApiCall<any>({ method: "post", url: "/seller/createContractor", data }),
  updateContractorById: (id: any, data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/seller/updateContractorById?id=${id}`,
      data,
    }),
  fetchContractorById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/seller/fetchCOntractorById?id=${id}`,
    }),

  // GSTIN Verification APIs
  verifyGstDetails: (data: {
    orgName: string;
    gstin: string;
  }): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/verifyLegalDetails",
      data,
    }),

  uploadGstFile: async (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    const url = `${process.env.REACT_APP_GST_URL}`;
    return axios.post(url, formData);
  },
};

export default contractorsApis;
